<div class="modal-header">
    <!-- TERMINAL CURATION CUT: bulk-curation nav prepended to the panel's modal-header
              (v1 curationModal.directive.js injected bulkCurationHeaderTemplate here via the
              modal-curation.show event). Rendered only in bulk mode ([bulkNav] set). -->
    @if (bulkNav(); as nav) {
        <ft-bulk-curation-nav-ng
            [hasPhoto]="nav.hasPhoto"
            [isDone]="nav.isDone"
            [total]="nav.total"
            (next)="bulkNext.emit()"
          />
    }
    <div class="modal-heading">{{ guest()?.first }}'s story</div>
</div>
<div class="ft-row">
    <div class="ft-col-55">
        <div class="content-pane">
            @if (hasPhoto()) {
                <div class="photo-content">
                    <div class="guest-photo">
                        @if (guest()?.poststay?.photo?.photoUrl) {
                            <img
                                class="img-responsive"
                                [src]="guest().poststay.photo.photoUrl"
                            />
                        }
                        <div class="guest-photo-actions">
                            @if (identity.isFliptoStaff()) {
                                <a
                                    ft-hide-mobile-and-tablet
                                    class="reprocess-button"
                                    (click)="reprocessImage.emit(); $event.stopPropagation()"
                                ></a>
                            }
                            @if (identity.isFliptoStaff()) {
                                <a
                                    ft-hide-mobile-and-tablet
                                    class="replace-button"
                                    (click)="showReplaceModal.emit()"
                                ></a>
                            }
                            <a
                                ft-hide-mobile-and-tablet
                                class="download-button"
                                (click)="downloadHighResImage.emit(); $event.stopPropagation()"
                            ></a>
                            <a class="edit-button" (click)="showImageModal.emit()"></a>
                        </div>
                    </div>
                </div>
            }
            @if (hasAiTags()) {
                <div class="tags-content" (click)="showImageModal.emit()">
                    <ul class="ft-tags">
                        @for (aiTag of guest()?.poststay?.photo?.ai?.tags; track aiTag) {
                            <li class="ft-tag">
                                {{ aiTag.value }}
                            </li>
                        }
                    </ul>
                </div>
            }
            @if (hasCaption()) {
                <div class="caption-content">
                    <div class="guest-caption">{{ guest()?.poststay?.photo?.caption }}</div>
                </div>
            }
            @if (hasPositiveQuote() || (hasQuote() && isInvitee())) {
                <div class="quote-content">
                    <div class="guest-quote">{{ guest()?.poststay?.quote?.notesPositive }}</div>
                </div>
            }
            <div class="guest-profile">
                <ft-image ft-profile-photo always-visible>
                    <div
                        class="ft-image-div ft-profile-pic"
                        [ftBackgroundImage]="guest()?.profileImageUrl"
                        [fallbackClass]="guest()?.silhouetteClass"
                    ></div>
                </ft-image>
                <div class="guest-name">{{ guest() | fullName }}</div>
                <ul class="guest-activity list-unstyled">
                    @if (isPiiInfoVisible()) {
                        <li>Email: {{ guest()?.email }}</li>
                    }
                    @if (isPiiInfoVisible() && guest()?.reservationNumber) {
                        <li>
                            Reservation#: {{ guest().reservationNumber }}
                        </li>
                    }
                    @if (!isInvitee()) {
                        <li>
                            {{ 'flipto.account.platform.BookedNumbRoomNightsOn' | translate: guest() }}
                            {{ guest()?.startDate | dateFormat: 'M/D/YYYY' }}
                        </li>
                    }
                    @if (isInvitee()) {
                        <li>
                            {{ 'flipto.account.platform.ContestInvitee' | translate }}
                            {{ guest()?.createDate | dateFormat: 'M/D/YYYY' }}
                        </li>
                    }
                </ul>
                <div style="margin-top: 5px;">
                    @if (!isPiiInfoVisible() && identity.hasPiiPermissions() && !isPiiDeleted()) {
                        <a
                            class="ft-btn ft-btn-outline-light"
                            (click)="showPiiInfo()"
                        >
                            {{ 'flipto.account.ShowInfo' | translate: guest() }}
                        </a>
                    }
                </div>
                <div style="margin-top: 5px;">
                    @if (isShowTimeline() && !isPiiDeleted()) {
                        <a
                            class="ft-btn ft-btn-outline-light"
                            (click)="openAdvocatePage.emit()"
                        >
                            {{ 'flipto.account.sections.platform.photoAdvocacy.ViewTimeline' | translate: guest() }}
                        </a>
                    }
                </div>
            </div>
        </div>
    </div>
    <div class="ft-col-45">
        @if (guest()?.poststay?.photo) {
            <div class="curation-pane">
                <div class="icon contest-board-icon"></div>
                <div class="curation-pane-heading">{{ guest().poststay.photo.photoContest?.name }}</div>
                <div class="curation-pane-heading contest">
                    {{
                        guest().poststay.photo.photoContest?.startDate
                            | dateRange: guest().poststay.photo.photoContest?.endDate
                    }}
                </div>
                @if (
                    guest().poststay.photo.photoContest?.startDate
                        | isNowInRange: guest().poststay.photo.photoContest?.votingEndDate
                ) {
                    <div
                        class="curation-pane-heading contest"
                        [class.ng-hide]="guest().poststay.photo.photoContest?.ended"
                    >
                        {{ 'flipto.account.sections.platform.photoAdvocacy.VotingEnds' | translate }}
                        {{ guest().poststay.photo.photoContest?.votingEndDate | dateFormat: 'MMM D, YYYY' }}
                    </div>
                }
                @if (
                    guest().poststay.photo.photoContest?.startDate
                        | isNowInRange: guest().poststay.photo.photoContest?.votingEndDate
                ) {
                    <div
                        class="curation-pane-heading contest"
                        [class.ng-hide]="!guest().poststay.photo.photoContest?.ended"
                    >
                        {{ 'flipto.account.sections.platform.photoAdvocacy.ContestHasEnded' | translate }}
                    </div>
                }
                @if (guest().poststay.photo.photoContest?.isClosed && guest().poststay.photo.place) {
                    <div>
                        <div class="contest-actions">
                            <div class="status">
                                {{ guest().poststay.photo.place | winnerPlace }}
                            </div>
                        </div>
                        {{ 'flipto.account.PhotoWasAWinner' | translate: guest() }}
                    </div>
                }
                <div [class.ng-hide]="!isNotReviewed(guest().poststay.photo)">
                    <div class="contest-actions">
                        <div class="status">
                            {{ 'flipto.account.sections.platform.photoAdvocacy.NotReviewed' | translate }}
                        </div>
                    </div>
                    {{
                        'flipto.account.sections.platform.photoAdvocacy.ThisPhotoWasNotPartOfTheContest'
                            | translate
                    }}
                </div>
                <div
                    [class.ng-hide]="
                        guest().poststay.photo.isPassed ||
                        guest().poststay.photo.isFinalist ||
                        guest().poststay.photo.photoContest?.isClosed
                    "
                >
                    <div class="contest-actions">
                        <div class="contest-actions-header">
                            {{ 'flipto.account.sections.platform.photoAdvocacy.AdvanceToContest' | translate }}
                        </div>
                        <button
                            class="ft-btn ft-btn-plus-1 btn-yes ft-btn-default"
                            (click)="advanceToFinal.emit(guest().poststay.photo)"
                        >
                            {{ 'flipto.account.Yes' | translate }}
                        </button>
                        <button
                            class="ft-btn ft-btn-plus-1 ft-btn-gray btn-no"
                            (click)="pass.emit(guest().poststay.photo)"
                        >
                            {{ 'flipto.account.No' | translate }}
                        </button>
                    </div>
                    <!-- [innerHTML], not {{ }}: the compat parser $sanitize-escapes every
                         translation (& -> &amp;) and v1's translate DIRECTIVE rendered that
                         via element.html() — text interpolation would paint the entity. -->
                    <span
                        [innerHTML]="
                            'flipto.account.sections.platform.photoAdvocacy.IfAdvancedReceiveEmail'
                                | translate: { first: guest()?.first }
                        "
                    ></span>
                </div>
                <div
                    [class.ng-hide]="
                        !(
                            guest().poststay.photo.isPassed &&
                            !(guest().poststay.photo.photoContest?.isClosed && guest().poststay.photo.place)
                        )
                    "
                >
                    <div class="contest-actions">
                        <div class="status">
                            {{ 'flipto.account.sections.platform.photoAdvocacy.NotAFinalist' | translate }}
                            @if (
                                guest().poststay.photo.photoContest?.startDate
                                    | isNowInRange: guest().poststay.photo.photoContest?.votingEndDate
                            ) {
                                <button
                                    class="ft-btn btn-sm ft-btn-default btn-contest-change"
                                    (click)="setPassedFalse()"
                                >
                                    {{ 'flipto.account.sections.platform.photoAdvocacy.Change' | translate }}
                                </button>
                            }
                        </div>
                    </div>
                    {{ 'flipto.account.sections.platform.photoAdvocacy.ThisPhotoWasPassed' | translate }}
                </div>
                <div
                    [class.ng-hide]="
                        !(
                            guest().poststay.photo.isFinalist &&
                            !(guest().poststay.photo.photoContest?.isClosed && guest().poststay.photo.place)
                        )
                    "
                >
                    <div class="contest-actions">
                        <div class="status">
                            {{ 'flipto.account.sections.platform.photoAdvocacy.Finalist' | translate }}
                        </div>
                    </div>
                    {{
                        'flipto.account.sections.platform.photoAdvocacy.ThisPhotoWasAdvanced' | translate: guest()
                    }}
                </div>
            </div>
        }

        @if (hasPhoto() || hasPositiveQuote()) {
            <div class="curation-pane">
                <div class="icon photo-library-icon"></div>
                <div class="curation-pane-heading">
                    {{ 'flipto.account.sections.platform.photoAdvocacy.Library' | translate }}
                </div>
                {{ 'flipto.account.sections.platform.photoAdvocacy.RateTheGuestsContent' | translate }}
                @if (hasPhoto()) {
                    <div class="content-rating photo-rating">
                        <div class="ft-label">
                            {{ 'flipto.account.sections.platform.photoAdvocacy.Photo' | translate }}
                        </div>
                        <ft-rating-ng [stars]="guest()?.poststay?.photo?.internalInfo?.['rating']"
                            (changed)="ratePhoto.emit($event)"
                          />
                    </div>
                }
                @if (hasCaption()) {
                    <div class="content-rating caption-rating">
                        <div class="ft-label">
                            {{ 'flipto.account.sections.platform.photoAdvocacy.Caption' | translate }}
                        </div>
                        <ft-rating-ng [stars]="guest()?.poststay?.photo?.internalInfo?.['captionRating']"
                            (changed)="rateCaption.emit($event)"
                          />
                    </div>
                }
                @if (hasPositiveQuote() || (hasQuote() && isInvitee())) {
                    <div class="content-rating quote-rating">
                        <div class="ft-label">
                            {{ 'flipto.account.sections.platform.photoAdvocacy.Quote' | translate }}
                        </div>
                        <ft-rating-ng [stars]="guest()?.poststay?.quote?.internalInfo?.['rating']"
                            (changed)="rateQuote.emit($event)"
                          />
                    </div>
                }
            </div>
        }

        @if (
            canWriteStories &&
            ((hasPhoto() && guest()?.poststay?.photo?.isFinalist) ||
                (!hasPhoto() && hasPositiveQuote())) &&
            !isPiiDeleted()
        ) {
            <div class="curation-pane">
                <div class="poststay-share-icon"></div>
                <div class="curation-pane-heading">
                    {{ 'flipto.account.Share' | translate }}
                </div>

                <div ft-hide-in-v1>
                    <button
                        class="ft-btn ft-btn-plus-1 ft-btn-outline-light ft-btn-broadcast"
                        (click)="broadcastStory.emit()"
                    >
                        Broadcast {{ guest()?.first }}'s story
                    </button>
                </div>
            </div>
        }

        @if (
            hasPhoto() &&
            (guest()?.poststay?.photo?.isPassed || !guest()?.poststay?.photo?.isFinalist) &&
            !isPiiDeleted()
        ) {
            <div class="curation-pane">
                <div class="poststay-share-icon"></div>
                <div class="curation-pane-heading">
                    {{ 'flipto.account.Share' | translate }}
                </div>
                <div class="share-unavailable-message">
                    {{ 'flipto.account.SharingNotAvailableNotFinalist' | translate: guest() }}
                </div>
            </div>
        }
    </div>
</div>
